import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import UiDimensions from "../../UI/ui-dimensions/UiDimensions";
import "../../UI/ui-animation/AUL.css";
import "../../UI/ui-key/UiKey.css";
import Coffee from "./Coffee";
import ExtraPage from "./ExtraPage";
import Header from "./Header";
import Bodi from "./Bodi";
import Footer from "./Footer";
import Modal from "./Modal";
import Game from "../game/Game";

const Wall = () => {
  const Width = UiDimensions().innerWidth;
  const Height = UiDimensions().innerHeight;
  const [isLogged, setisLogged] = useState(false);
  const [Extra, setExtra] = useState(null);
  const [Login, setLogin] = useState(null);
  const [Register, setRegister] = useState(null);
  const [MoreInfo, setMoreInfo] = useState(null);
  const [ShowModal, setShowModal] = useState([
    { SHOW: false, PM1: "", PM2: "", PM3: "" },
  ]);
  const [Loading, setLoading] = useState(false);
  const [EmailRepeat, setEmailRepeat] = useState("");
  useEffect(() => {
    setExtra(null);
    setMoreInfo(null);
    setRegister(null);
    setLogin(null);
  }, [Width]);
  return (
    <React.Fragment>
      <Modal
        ShowModal={ShowModal}
        setShowModal={setShowModal}
        Width={Width}
        Height={Height}
        Loading={Loading}
        setLoading={setLoading}
        EmailRepeat={EmailRepeat}
      />
      {!isLogged ? (
        <Box className="Wrapper">
          <ExtraPage
            Width={Width}
            Height={Height}
            Extra={Extra}
            setExtra={setExtra}
            Login={Login}
            Register={Register}
            MoreInfo={MoreInfo}
            Loading={Loading}
            setLoading={setLoading}
            setEmailRepeat={setEmailRepeat}
            setShowModal={setShowModal}
            setisLogged={setisLogged}
          />
          <Box
            sx={{
              position: "fixed",
              width: Width < 560 ? "90%" : "100%",
              height: Width < 560 ? "70vh" : "90vh",
              marginTop: "5vh",
              marginLeft: Width < 560 ? "5%" : "0",
              display: "flex",
              flexDirection: "column",
              fontFamily: "Aboreto",
              fontSize: "0.8rem",
            }}
          >
            <Header
              Width={Width}
              Height={Height}
              setExtra={setExtra}
              setLogin={setLogin}
              setRegister={setRegister}
              setMoreInfo={setMoreInfo}
            />
            <Bodi
              Width={Width}
              Height={Height}
              setExtra={setExtra}
              setLogin={setLogin}
              setRegister={setRegister}
              setMoreInfo={setMoreInfo}
              Login={Login}
              Register={Register}
              setShowModal={setShowModal}
              Loading={Loading}
              setLoading={setLoading}
              setEmailRepeat={setEmailRepeat}
              setisLogged={setisLogged}
            />
            <Footer Width={Width} Height={Height} />
          </Box>
          <Coffee Width={Width} Height={Height} />
        </Box>
      ) : (
        <Game />
      )}
    </React.Fragment>
  );
};

export default Wall;
